import React from 'react';

// Copy pasted from Taco until the component is exported
export const useTruncated = (element: HTMLElement | null, deps: any[] = []) => {
    const isTruncated = (targetElement: HTMLElement | null) => {
        if (targetElement !== null) {
            return targetElement.offsetWidth < targetElement.scrollWidth;
        }

        return false;
    };
    const [truncated, setTruncated] = React.useState<boolean>(isTruncated(element));

    React.useEffect(() => {
        setTruncated(isTruncated(element));
    }, [element, ...deps]);

    return { truncated };
};
